import { createListFilters } from 'app/components'

export type NotificacoesFilters = {
  /** Só as notificações ainda não lidas. Só `true` ou ausente. */
  somenteNaoLidas?: true
}

export const { ListFiltersProvider, useListFilters } = createListFilters<NotificacoesFilters>({
  somenteNaoLidas: undefined,
})
